import styled from 'styled-components';

// const PickContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//
//   @media (max-width: ${props => props.theme.breakpoints.values.md - 1}px) {
//     min-height: calc(100vh - ${props => props.theme.spacing(13)}px);
//     margin-bottom: ${props => props.theme.spacing(6)}px;
//   }
// `;

const PickContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${props => props.theme.breakpoints.values.md - 1}px) {
    height: calc(100vh - 56px);
  }
`;

export default PickContainer;
